import { render, staticRenderFns } from "./m_notFoundPage.vue?vue&type=template&id=172c74c4&scoped=true&"
import script from "./m_notFoundPage.vue?vue&type=script&lang=js&"
export * from "./m_notFoundPage.vue?vue&type=script&lang=js&"
import style0 from "./m_notFoundPage.vue?vue&type=style&index=0&id=172c74c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c74c4",
  null
  
)

export default component.exports